export const COUPLE = {
  nickname1: "Talita",
  nickname2: "Rodrigo",
  names: "Rodrigo & Talita",
  fullNames: "Rodrigo Aristeu Pereira e Talita Henriques da Silva",
  weddingDateISO: "2027-01-09T16:00:00-03:00",
  dateLabel: "SÁBADO — 09 . 01 . 2027 — ÀS 16H",
};

export const EVENT = {
  local: "Dom Guilherme Eventos",
  endereco1: "R. Ademar Castilho - S/Nº (final da rua)",
  endereco2: "Almirante Tamandaré - PR",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=-25.3305005%2C-49.3100708",
};

export const ASSESSORIA = {
  numeroLabel: "(41) 99656-9819",
  whatsappUrl: "https://wa.me/5541996569819",
  contato: "Patricia Broto",
  prazo: "03/12/2026",
};

export const SHARE_TEXT =
  "Aqui contamos os momentos mais marcantes da nossa história de amor. Dê o play e ouça a nossa música, composta pelo Rodrigo para a Talita, inspirada na nossa linda história. ❤️";

export const MUSIC_ASK_TEXT =
  "Esse site possui uma playlist musical. Deseja reproduzir enquanto navega?";

export const WELCOME = {
  title: "Sejam bem-vindos ao nosso site!",
  paragraphs: [
    "Queridos familiares e amigos,",
    "Bem-vindos!",
    "Entre sonhos, orações e muitos planos construídos juntos, chegou o momento de celebrar o capítulo mais especial das nossas vidas: o nosso casamento.",
    "Existem momentos na vida com os quais sonhamos por muito tempo, e poder viver este ao lado de pessoas tão especiais torna tudo ainda mais bonito.",
    "Estamos contando os dias para celebrar o nosso amor e escrever mais um capítulo da nossa história, cercados por quem faz parte dela. Cada abraço, sorriso e presença tornarão esse dia ainda mais inesquecível.",
    "Criamos este espaço para compartilhar com vocês todos os detalhes do nosso casamento e, principalmente, a felicidade de viver esse momento tão único.",
    "Esperamos que aproveitem cada detalhe e contem os dias conosco até o nosso tão esperado “sim”!",
    "Obrigada por fazerem parte da nossa história ❤️",
  ],
  signature: "Com amor,",
  names: "Talita & Rodrigo",
};

export const HISTORY = {
  title: "Nossa história",
  paragraphs: [
    "Nossa história começou em 13 de fevereiro de 2021, durante um jantar no apartamento da Talita. O que parecia ser apenas uma noite comum acabou se tornando o início do maior sonho das nossas vidas.",
    "Entre conversas, risadas e a descoberta de tantas afinidades, percebemos que havia algo especial acontecendo. Aos poucos, a amizade e a admiração deram lugar a um sentimento cada vez mais forte, transformando-se em um amor que crescia a cada dia.",
    "O tempo passou, mas a vontade de estarmos juntos só aumentava. Em maio de 2021, decidimos morar juntos, afinal, já não conseguíamos imaginar nossos dias um sem o outro. Desde então, temos vivido inúmeras bênçãos, compartilhado sonhos, enfrentado desafios, celebrado conquistas e construído uma parceria baseada em amor, respeito, confiança e companheirismo. Cada momento vivido fortaleceu ainda mais a certeza de que queríamos caminhar lado a lado pela vida.",
    "E então, em 26 de dezembro de 2021, uma data que já era especial por ser o aniversário da Talita, veio também o tão sonhado pedido de casamento. Um momento inesquecível, repleto de emoção, que marcou o início dos preparativos para a realização de mais um grande sonho.",
    "Com o passar dos anos, tivemos a certeza de que nosso lugar favorito sempre seria ao lado um do outro. E é com essa certeza, com muito amor e gratidão, que decidimos escrever um novo capítulo da nossa história: o nosso casamento.",
    "Estamos muito felizes em compartilhar este momento com as pessoas que fizeram e fazem parte da nossa trajetória. Ter vocês conosco neste dia tão especial tornará nossa celebração ainda mais inesquecível.",
    "O melhor da nossa história não é apenas tudo o que vivemos até aqui, mas principalmente tudo o que ainda vamos viver juntos.",
  ],
};

export const PADRINHOS = {
  title: "Padrinhos",
  paragraphs: [
    "Aos nossos Padrinhos,",
    "Existem pessoas que cruzam nosso caminho e deixam marcas especiais. Pessoas que compartilham alegrias, oferecem apoio nos momentos difíceis, celebram nossas conquistas e tornam a vida mais bonita simplesmente por estarem presentes.",
    "Vocês são essas pessoas para nós.",
    "Ao longo da nossa história, cada um de vocês fez parte de momentos importantes, contribuiu de alguma forma para quem somos hoje e ajudou a fortalecer os laços que construímos. Por isso, quando pensamos em quem gostaríamos de ter ao nosso lado no dia mais especial das nossas vidas, seus nomes vieram ao nosso coração de forma natural.",
    "Ser padrinho e madrinha não é apenas ocupar um lugar de destaque em nossa cerimônia. É representar amizade, carinho, confiança, amor e a certeza de que estamos cercados por pessoas que desejam nossa felicidade.",
    "Somos imensamente gratos por poder compartilhar este sonho com vocês. Obrigado por aceitarem caminhar ao nosso lado neste momento tão importante e por fazerem parte da nossa história de amor.",
    "Que este seja apenas mais um dos muitos capítulos felizes que ainda viveremos juntos.",
  ],
  signature: "Com todo nosso carinho e gratidão,",
  names: "Talita & Rodrigo",
};

export const GIFTS_INTRO =
  "“O maior presente é ter vocês conosco nesse dia tão especial! Mas, para quem deseja nos presentear, criamos uma lista diferente, cheia de carinho, sonhos e algumas boas doses de humor. Cada presente representa um pedacinho da nossa vida juntos. Obrigado por fazerem parte da nossa história!” ❤️";

export const MESSAGES = {
  title: "Deixe sua mensagem de carinho para nós",
  subtitle:
    "Palavras são carinhos doados. Obrigado por nos dar o seu carinho. Iremos lembrar para sempre deste momento tão esperado.",
};

export const RSVP = {
  title: "Confirmação de presença",
  subtitle: "Faça parte da nossa história de amor, confirme sua presença.",
  deadlineLabel: "03 de dezembro de 2026",
  categories: {
    adulto: { label: "Adulto", desc: "A partir de 12 anos" },
    crianca: { label: "Criança", desc: "De 05 anos a 11 anos" },
    bebe: { label: "Bebê", desc: "Até 04 anos" },
  },
};

export const DICAS = {
  title: "Dicas",
  subtitle:
    "Algumas informações importantes para ajudar vocês, nossos queridos convidados, a se prepararem para o nosso grande dia. ❤️",
};
